module.exports = __webpack_public_path__ + "assets/images/backQueue.b75d8.png";